import { Search } from "lucide-react";
import { Button, Heading, Link, Stack } from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";

export const NotFound = () => {
  return (
    <Stack align="center">
      <Search size={48} />
      <Heading size="xl">404 - Finner ikke siden</Heading>
      <Link asChild>
        <ReactRouterLink to={"/invoices/"}>
          <Button variant="solid" mt={8}>
            Tilbake
          </Button>
        </ReactRouterLink>
      </Link>
    </Stack>
  );
};
